/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedTradeRewardsBenefitCard_user$ref = any;
export type PdpSharedTradeRewardsBenefitCardLoader_user$ref = any;
export type PdpSharedTradeRewardsBenefitCardLoader_user = {
    readonly " $fragmentRefs": PdpSharedTradeRewardsBenefitCard_user$ref;
    readonly " $refType": PdpSharedTradeRewardsBenefitCardLoader_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedTradeRewardsBenefitCardLoader_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedTradeRewardsBenefitCard_user",
      "args": null
    }
  ]
};
(node as any).hash = 'c9155c8f859ff8f6867b17953cb75485';
export default node;
